export const processData = (inputData) => {
  const access = inputData.access || [];
  const pullCurrent = inputData.pullCurrent || [];
  const message = inputData.message || [];
  const storage = inputData.storage || [];
  const ai = inputData.ai || [];
  const other = inputData.other || "";

  // 用于存储非空数组的值
  const features = [];

  // 检查每个字段是否有值并将其添加到 features 中
  if (access.length > 0) features.push(...access);
  if (pullCurrent.length > 0) features.push(...pullCurrent);
  if (message.length > 0) features.push(...message);
  if (storage.length > 0) features.push(...storage);
  if (ai.length > 0) features.push(...ai);

  // 创建输出对象
  const output = {};

  // 检查 other 的有效性
  const isOtherValid =
    other !== undefined && other !== null && other.trim().length > 0;

  // 如果 other 有效且 features 不为空，则添加 useFeatures 字段
  if (isOtherValid) {
    output.otherFeatures = other;

    if (features.length > 0) {
      output.useFeatures = features.join(",");
    }
  } else if (features.length > 0) {
    // 如果 other 无效，但是 features 有值，则只生成 useFeatures
    output.useFeatures = features.join(",");
  }

  return output;
};
